(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3081],{

/***/ 61591:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc",
      function () {
        return __webpack_require__(90362);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gc": function() { return /* binding */ HOME_BANNER_OPTIONS; },
  "kp": function() { return /* binding */ useFetchBanners; }
});

// UNUSED EXPORTS: DEFAULT_BANNER_OPTIONS, fetchBanners

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./apis/fetch.js
var fetch = __webpack_require__(36203);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(59926);
;// CONCATENATED MODULE: ./apis/queryKeys/bannersKeys.js


var sort = {
    date_created: -1
};
var bannersKeys = {
    all: [
        {
            scope: "ecombanners",
            limit: 100,
            sort: sort
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecombanners",
                type: "count"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(vi_tri) {
        return [
            {
                scope: "ecombanners",
                type: "list",
                vi_tri: vi_tri
            }, 
        ];
    },
    detail: function(_id) {
        return [
            {
                scope: "ecombanners",
                type: "detail",
                _id: _id
            }
        ];
    }
};
/* harmony default export */ var queryKeys_bannersKeys = (bannersKeys);

;// CONCATENATED MODULE: ./apis/queryFunctions/banner.js








var DEFAULT_STALE_TIME = 60000 * 5; // 5min
var DEFAULT_BANNER_OPTIONS = {
    sort: {
        stt: 1
    },
    limit: 5,
    condition: {
        status: true,
        shared: true
    }
};
var HOME_BANNER_OPTIONS = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_BANNER_OPTIONS), {
    condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_BANNER_OPTIONS.condition), {
        vi_tri: "home-top-sliders-cafe"
    })
});
var fetchBanners = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var options, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    return _ctx.abrupt("return", (0,fetch/* asyncGetList */.NE)({
                        collection_name: "ecombanners",
                        options: options
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBanners() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchBanners = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var locale = (0,router.useRouter)().locale;
    var mergeOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (options === null || options === void 0 ? void 0 : options.condition) || {}), {
            ngon_ngu: locale
        })
    });
    return (0,useQuery/* useQuery */.a)(queryKeys_bannersKeys.list(mergeOptions), function() {
        return fetchBanners(mergeOptions);
    }, {
        enabled: !!(options === null || options === void 0 ? void 0 : (ref = options.condition) === null || ref === void 0 ? void 0 : ref.vi_tri),
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(banners) {
            banners.map(function(banner) {
                queryClient.setQueriesData(queryKeys_bannersKeys.detail(banner === null || banner === void 0 ? void 0 : banner._id), banner);
            });
        }
    });
};


/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useFetchNewsArticles; },
/* harmony export */   "G9": function() { return /* binding */ useFetchNewsArticle; },
/* harmony export */   "aC": function() { return /* binding */ useFetchNewsArticlesCount; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_FETCHING_NEWS_OPTIONS; }
/* harmony export */ });
/* unused harmony exports fetchNewsArticle, fetchNewsArticles, fetchNewsArticlesCount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







var DEFAULT_STALE_TIME = 1000 * 60 * 30; // 30 min
var DEFAULT_FETCHING_NEWS_OPTIONS = {
    limit: 8,
    page: 1,
    condition: {
        ngon_ngu: "vi",
        loai_tin_tuc: "Tin tức c\xe0 ph\xea"
    }
};
var fetchNewsArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug
                            }
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticle(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticle = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(slug), function() {
        return fetchNewsArticle(slug);
    }, {
        // staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 8,
                            sort: {
                                stt: 1,
                                date_created: -1
                            }
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: true,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticles() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticles = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.list */ .w3.list(options), function() {
        return fetchNewsArticles(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(newsArticles) {
            newsArticles.map(function(newsArticle) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.slug), newsArticle);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticlesCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, locale, data, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, locale = _args.length > 1 ? _args[1] : void 0;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: {
                            count: true,
                            condition: {
                                ngon_ngu: locale,
                                isnews: true,
                                loai_tin_tuc: "Tin tức c\xe0 ph\xea"
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticlesCount() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticlesCount = function(options, locale) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.count */ .w3.count((options === null || options === void 0 ? void 0 : options.condition) || {}), function() {
        return fetchNewsArticlesCount(options, locale);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 34964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95117);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);







var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .createStyles */ .k)(function() {
    return {
        imageWrapper: {
            width: "100%",
            aspectRatio: "1.5",
            position: "relative"
        }
    };
});
function NewCard(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = useStyles().classes;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Z, {
        shadow: "sm",
        p: 0,
        radius: "sm",
        sx: {
            height: "100%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                            visible: isLoading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card.Section */ .Z.Section, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes.imageWrapper,
                                    children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                            src: item === null || item === void 0 ? void 0 : item.picture,
                                            size: "s"
                                        }),
                                        alt: "Norway",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                            p: "md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        style: {
                                            letterSpacing: 1
                                        },
                                        transform: "uppercase",
                                        size: "sm",
                                        lineClamp: 2,
                                        weight: "500",
                                        children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        size: "xs",
                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (item === null || item === void 0 ? void 0 : item.thong_tin_km) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/khuyen_mai.png",
                style: {
                    width: 64,
                    top: -10,
                    right: -10,
                    position: "absolute"
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NewCard);


/***/ }),

/***/ 69892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TitlePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9094);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19236);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function TitlePage(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M, {
        py: 20,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .D, {
            order: 3,
            children: children
        })
    });
};


/***/ }),

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59963);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);





function AppBreadcrumbs(param) {
    var items = param.items, isLoading = param.isLoading;
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__/* .useLocalContext */ .u)().getLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumbs */ .O, {
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: item.href || "#",
                    scroll: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                            color: "dark",
                            size: "sm",
                            lineClamp: index === items.length - 1 ? 1 : 2,
                            sx: {
                                width: index === items.length - 1 ? "fit-content" : "max-content"
                            },
                            children: getLabel(item.title)
                        })
                    })
                }, index);
            })
        })
    });
}
AppBreadcrumbs.propTypes = {
    items: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (AppBreadcrumbs);


/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);


function DefaultSEO(param) {
    var seo = param.seo;
    if (!seo) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: "".concat("https://api.flexzen.app").concat(seo.picture1, "?access_token=flex.public.token&trustkey=APP.FKJSHHHH908KJF"),
            width: 1200,
            height: 630,
            alt: "Zemor logo",
            type: "image/*"
        });
    }
    if (seo.picture2) {
        images.push({
            url: "".concat("https://api.flexzen.app").concat(seo.picture2, "?access_token=flex.public.token&trustkey=APP.FKJSHHHH908KJF"),
            width: 1200,
            height: 1200,
            alt: "Zemor logo",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo.title || "ZeMor Coffee",
        description: seo.description,
        openGraph: {
            url: "https://zemor.vn",
            title: seo.title,
            description: seo.description,
            images: images,
            site_name: "ZeMor Coffee"
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 95101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PrevArrow; },
/* harmony export */   "g": function() { return /* binding */ NextArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16829);
/* harmony import */ var _react_icons_all_files_bs_BsChevronLeft__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77299);
/* harmony import */ var _react_icons_all_files_bs_BsChevronRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  transform: translateY(-40%);\n  z-index: 99;\n\n  & svg {\n    cursor: pointer;\n    fill: white;\n    width: 32px;\n    height: 56px;\n    /* border-radius: 30px; */\n    background-color: rgba(0, 0, 0, 0.2);\n    padding: 0;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.4);\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), function(props) {
    return props.slider ? "50%" : "150px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.left) ? "left: 0;" : "right: 0;";
}, function(props) {
    return !(props === null || props === void 0 ? void 0 : props.slider) && ((props === null || props === void 0 ? void 0 : props.left) ? "transform: translate(-100%, -40%);" : "transform: translate(100%, -40%);");
});
function NextArrow(param) {
    var onClick = param.onClick, _slider = param.slider, slider = _slider === void 0 ? false : _slider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        right: true,
        slider: slider,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_bs_BsChevronRight__WEBPACK_IMPORTED_MODULE_4__/* .BsChevronRight */ .f, {
            onClick: onClick
        })
    });
}
function PrevArrow(param) {
    var onClick = param.onClick, _slider = param.slider, slider = _slider === void 0 ? false : _slider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        left: true,
        slider: slider,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_bs_BsChevronLeft__WEBPACK_IMPORTED_MODULE_5__/* .BsChevronLeft */ .p, {
            onClick: onClick
        })
    });
}


/***/ }),

/***/ 90362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ NewsPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/news.js
var queryFunctions_news = __webpack_require__(11775);
// EXTERNAL MODULE: ./apis/queryFunctions/banner.js + 1 modules
var banner = __webpack_require__(88517);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var utils_appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 22 modules
var es = __webpack_require__(16530);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/components/SliderArrows.js
var SliderArrows = __webpack_require__(95101);
;// CONCATENATED MODULE: ./common/components/BannerTop.js












var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        container: {
            width: "100%",
            maxHeight: "calc(100vh - 100px)",
            // aspectRatio: "2.44",
            position: "relative",
            transition: "0.3s"
        },
        sliderItem: {
            width: "100%",
            maxHeight: "calc(100vh - 100px)",
            // aspectRatio: "2.27",
            // aspectRatio: "2.44",
            transition: "0.3s",
            position: "relative"
        },
        dotsClass: {
            position: "absolute",
            bottom: "10px",
            width: "100%",
            listStyle: "none",
            textAlign: "center",
            padding: 0,
            margin: 0,
            // "& li button:before": {
            //   fontSize: "10px !important",
            // },
            // "& li.slick-active button:before": {
            //   color: "#EBBC1D",
            // },
            "& li": {
                position: "relative",
                display: "inline-block",
                width: "20px",
                height: "20px",
                margin: "0 5px",
                padding: "0",
                cursor: "pointer"
            },
            "& li button": {
                fontSize: 0,
                lineHeight: 0,
                display: "block",
                width: "20px",
                height: "20px",
                padding: "5px",
                cursor: "pointer",
                color: "transparent",
                border: 0,
                outline: "none",
                background: "transparent"
            },
            "& li button:after": {
                // content: "'⚫'",
                fontFamily: "slick",
                fontSize: "10px",
                lineHeight: "20px",
                position: "absolute",
                top: 0,
                left: 0,
                width: "20px",
                height: "20px",
                content: "'•'",
                textAlign: "center",
                opacity: 0.25,
                color: theme.colors.second[0]
            },
            "& li.slick-active button:after": {
                opacity: ".75",
                color: "#EBBC1D"
            }
        }
    };
});
function BannerTop(param) {
    var position = param.position, aspectRatio = param.aspectRatio;
    var classes = useStyles().classes;
    var ref = useFetchBanners({
        condition: {
            vi_tri: position,
            shared: true
        },
        sort: {
            sst: 1
        }
    }), sliders = ref.data;
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // appendDots: (dots) => <ul className={classes.dotsClass}>{dots}</ul>,
        dotsClass: classes.dotsClass,
        arrows: true,
        nextArrow: /*#__PURE__*/ _jsx(NextArrow, {}),
        prevArrow: /*#__PURE__*/ _jsx(PrevArrow, {})
    };
    return /*#__PURE__*/ _jsx(Skeleton, {
        visible: !sliders,
        children: /*#__PURE__*/ _jsx("div", {
            className: classes.container,
            id: "banners",
            style: {
                aspectRatio: "".concat(aspectRatio, " !important"),
                width: "100%"
            },
            children: /*#__PURE__*/ _jsx(Slider, _object_spread_props(_object_spread({}, settings), {
                children: sliders && sliders.map(function(item) {
                    return /*#__PURE__*/ _jsx(Link, {
                        href: getHrefLinkOfBanner(item),
                        scroll: false,
                        children: /*#__PURE__*/ _jsx("a", {
                            children: /*#__PURE__*/ _jsx(Box, {
                                className: classes.sliderItem,
                                sx: {
                                    aspectRatio: "".concat(aspectRatio, " !important")
                                },
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: appendImageUrlFromAPI({
                                        src: item.hinh_anh,
                                        size: "xl"
                                    }),
                                    alt: "a",
                                    layout: "fill",
                                    priority: true,
                                    quality: 100
                                })
                            })
                        })
                    }, item._id);
                })
            }))
        })
    });
};

// EXTERNAL MODULE: ./common/components/Breadcrumbs.js
var Breadcrumbs = __webpack_require__(48285);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./common/NewCard/index.js
var NewCard = __webpack_require__(34964);
// EXTERNAL MODULE: ./common/Typography/TitlePage.js
var TitlePage = __webpack_require__(69892);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box_Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.js + 9 modules
var Pagination = __webpack_require__(7804);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/hi/HiOutlineEmojiSad.js
var HiOutlineEmojiSad = __webpack_require__(49067);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/tin-tuc/index.page.js
















var __N_SSG = true;
function NewsPage() {
    var locale = (0,router.useRouter)().locale;
    var breadcrumbs = [
        {
            title: locale === "vi" ? "Trang chủ" : "Home",
            href: "/"
        },
        {
            title: locale === "vi" ? "Tin tức" : "News",
            href: "/tin-tuc"
        }, 
    ];
    var limit = 8;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), page = ref[0], setPage = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState({
        limit: 8,
        page: 1,
        condition: {
            ngon_ngu: locale,
            loai_tin_tuc: "Tin tức c\xe0 ph\xea"
        }
    }), 2), options = ref1[0], setOptions = ref1[1];
    var ref2 = (0,queryFunctions_news/* useFetchNewsArticles */.AB)(options), news = ref2.data;
    var ref3 = (0,queryFunctions_news/* useFetchNewsArticlesCount */.aC)({
        limit: 8,
        page: 1,
        collection_name: "news",
        condition: {
            ngon_ngu: locale,
            loai_tin_tuc: "Tin tức c\xe0 ph\xea"
        }
    }, locale), newsCount = ref3.data;
    react.useEffect(function() {
        setOptions(function(prevOps) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevOps), {
                page: page,
                condition: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevOps === null || prevOps === void 0 ? void 0 : prevOps.condition), {
                    ngon_ngu: locale
                })
            });
        });
    }, [
        page,
        locale
    ]);
    var seo = {
        title: "Tin tức"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* Box */.x, {
                    py: 20,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            items: breadcrumbs,
                            isLoading: !breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitlePage/* default */.Z, {
                            children: locale === "vi" ? "Tin tức" : "News"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* Box */.x, {
                            mb: 20,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                                children: news ? news.slice(0, limit).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        lg: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                            item: item
                                        })
                                    }, item._id);
                                }) : Array(limit).fill(undefined).map(function(item, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        lg: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                            item: item,
                                            isLoading: true
                                        })
                                    }, i);
                                })
                            })
                        }),
                        !!newsCount > 0 && limit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                                page: page,
                                onChange: setPage,
                                total: Math.ceil(newsCount / limit),
                                size: "xs"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* Box */.x, {
                            sx: function(theme) {
                                return {
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexGrow: 1,
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingTop: 40,
                                    paddingBottom: 40
                                };
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HiOutlineEmojiSad/* HiOutlineEmojiSad */.q, {
                                    size: 32
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    align: "center",
                                    children: locale === "vi" ? "Kh\xf4ng c\xf3 tin tức tồn tại" : " No news exists"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6530,7435,9774,2888,179], function() { return __webpack_exec__(61591); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);